import http from './http'

const base = '/Telas/Ledger'

export default {
  async getOptions () { return (await http.get(`${base}/GetOptions`)).data },
  async getTransactions (params) { return (await http.get(`${base}/GetTransactions`, { params })).data },
  async getTransaction (id) { return (await http.get(`${base}/GetTransaction/${id}`)).data },
  async getBalances (params) { return (await http.get(`${base}/GetBalances`, { params })).data },
  async getRequests (params) { return (await http.get(`${base}/GetRequests`, { params })).data },
  async getConfigurations () { return (await http.get(`${base}/GetConfigurations`)).data },
  async updateConfiguration (ownerId, input) { await http.put(`${base}/UpdateConfiguration/${ownerId}`, input) },
  async getMappings (params) { return (await http.get(`${base}/GetMappings`, { params })).data },
  async addMapping (input) { return (await http.post(`${base}/AddMapping`, input)).data },
  async updateMapping (id, input) { await http.put(`${base}/UpdateMapping/${id}`, input) },
  async deleteMapping (id) { await http.delete(`${base}/DeleteMapping/${id}`) },
  async addManualTransaction (input) { return (await http.post(`${base}/AddManualTransaction`, input)).data },
  async reprocess (id) { await http.post(`${base}/Reprocess/${id}`, {}) },
  async ignore (id, reason) { await http.post(`${base}/Ignore/${id}`, { reason }) }
}
